export const API_URL = "https://cmd2022.ferrari.com/api/";
//export const API_URL = "https://api-arena-local.plesh.co/";
